module.exports = __webpack_public_path__ + "static/media/vishes_kansal.275a9da1.jpg";